export const e2p = (s: string) => s.replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[Number(d)]);

export const p2e = (s: string) =>
  s.replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d).toString());

export const isValidPhonenNumber = (number: string) => {
  const regex = new RegExp("^(\\+98|0)?9\\d{9}$");
  return regex.test(number);
};

export function extractPath(url: string) {
  let match = url.match(/^https?:\/\/[^\/]+(\/.*)$/);
  return match ? match[1]?.slice(1) : null;
}
